import { defineCustomElement } from "vue";
import AddHorse from "./components/AddHorse.ce.vue";

const customElement = defineCustomElement(AddHorse);
customElements.define("add-horse-btn", customElement);
